import VueImgSrc from './VueImgSrc'
import Breakpoints from 'nespresso-library/src/utils/breakpoints'
import isTouch from 'nespresso-library/src/utils/isTouch'
import { toggleClass } from 'gaspard'

const html = document.documentElement

export default class VueMedia {
    static install (Vue, options = {}) {
        Object.defineProperties(Vue.prototype, {
            $media: {
                get () { return this.$root._media }
            },
            $imgSuffix: {
                get () { return this.$root._imgSuffix }
            },
            $breakpoint: {
                get () { return this.$root._breakpoint }
            },
            $landscape: {
                get () { return this.$root._landscape }
            },
            $portrait: {
                get () { return this.$root._portrait }
            },
            $touch: {
                get () { return isTouch }
            }
        })
        Vue.mixin({
            beforeCreate () {
                if (this.$parent === undefined) {
                    Vue.util.defineReactive(this, '_imgSuffix', this._imgSuffix)
                    Vue.util.defineReactive(this, '_breakpoint', this._breakpoint)
                    Vue.util.defineReactive(this, '_landscape', this._landscape)
                    Vue.util.defineReactive(this, '_portrait', this._portrait)
                } else if (this.$parent === this.$root) {
                    this.$root._media = new VueMedia(this.$root, options)
                }
            }
        })
        Vue.use(VueImgSrc, options.imgSrc)
        toggleClass(html, 'g_isTouch', isTouch)
    }

    constructor (app, { breakpoints, getImgSuffix }) {
        const bp = this.breakpoints = new Breakpoints(breakpoints)
        bp.on('change', changes => {
            app._breakpoint = changes.current
            app._landscape = changes.landscape
            app._portrait = changes.portrait
            app._imgSuffix = getImgSuffix ? getImgSuffix(changes.current, changes.landscape, changes.portrait) : `_${changes.current.name.toUpperCase()}_${changes.landscape ? 'L' : 'P'}`
            toggleClass(html, 'g_landscape', changes.landscape)
            toggleClass(html, 'g_portrait', !changes.landscape)
            toggleClass(html, `g_${changes.last.name}`, false)
            toggleClass(html, `g_${changes.current.name}`, true)
        }, true)
    }
}



// WEBPACK FOOTER //
// ./node_modules/nespresso-components/media/VueMedia.js